import React from 'react';
import { Chip, Stack, IconButton, Tooltip } from '@mui/material';
import { ListInvestorCollaborationsDTO } from '@inversor-hub/types';
import EditIcon from '@mui/icons-material/Visibility';

export interface CollaborationStatusLabelProps {
  psiId: string;
  collaborations: ListInvestorCollaborationsDTO[];
  onOpenContract: (collabId: string) => void;
}

export const PsiCardCollaborationStatusLabel: React.FC<CollaborationStatusLabelProps> = ({
  psiId,
  collaborations,
  onOpenContract,
}) => {
  const collab = collaborations.find((c) => c.psiId === psiId);
  if (!collab) return null;

  if (collab.rejectedAt) {
    return (
      <Chip
        label="Colaboración rechazada"
        sx={{
          bgcolor: (t) => t.palette.error.main,
          color: (t) => t.palette.common.white,
          fontWeight: 500,
        }}
      />
    );
  }

  if (collab.investorSigned && collab.psiSigned) {
    return (
      <>
        <Tooltip title="Ver contrato firmado">
          <IconButton onClick={() => onOpenContract(collab.id)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </>
    );
  }

  if (collab.investorSigned) {
    return (
      <Chip
        label="Solicitud enviada, esperando aceptación"
        sx={{
          bgcolor: (t) => t.palette.warning.main,
          color: (t) => t.palette.common.black,
          fontWeight: 500,
        }}
      />
    );
  }
  return (
    <Stack direction="column" spacing={1} alignItems="flex-end">
      <Chip
        label="Reserva tu oportunidad en la sección 'Mis intereses'"
        color="success"
        sx={{ fontWeight: 500 }}
      />
    </Stack>
  );
};
